import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user']),
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover este Visitante/Prestador?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/visitor/resources/computed.js